var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3355 26.6675V20.833C20.3355 20.0563 20.3355 19.6679 20.2086 19.3616C20.0394 18.9531 19.7149 18.6286 19.3064 18.4594C19.0001 18.3325 18.6117 18.3325 17.835 18.3325C17.0583 18.3325 16.6699 18.3325 16.3636 18.4594C15.9551 18.6286 15.6306 18.9531 15.4614 19.3616C15.3345 19.6679 15.3345 20.0563 15.3345 20.833V26.6675M26.17 18.2033V19.9995C26.17 22.3335 26.17 23.5005 25.7158 24.392C25.3162 25.1762 24.6787 25.8137 23.8945 26.2133C23.003 26.6675 21.836 26.6675 19.502 26.6675H16.168C13.834 26.6675 12.667 26.6675 11.7755 26.2133C10.9913 25.8137 10.3538 25.1762 9.95423 24.392C9.5 23.5005 9.5 22.3335 9.5 19.9995V18.2033C9.5 17.0264 9.5 16.438 9.64967 15.8947C9.78227 15.4133 10.0003 14.9598 10.2933 14.5555C10.624 14.0993 11.0835 13.7317 12.0025 12.9965L13.6695 11.6629C15.1562 10.4736 15.8995 9.87892 16.7238 9.65087C17.4509 9.44971 18.2191 9.44971 18.9462 9.65087C19.7705 9.87892 20.5138 10.4736 22.0005 11.6629L23.6675 12.9965C24.5865 13.7317 25.046 14.0993 25.3767 14.5555C25.6697 14.9598 25.8877 15.4133 26.0203 15.8947C26.17 16.438 26.17 17.0264 26.17 18.2033Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#F3F4F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.79bcda85.svg";
export { ForwardRef as ReactComponent };